// src/UI/Table/TableHeader.tsx
import React from "react";
import { Box } from "@mui/material";
import Button from "../Button/Button"; // ваш кастомный Button
import AddIcon from "@mui/icons-material/Add";
import { useTranslation } from "react-i18next";

// Импортируем SearchBar
import SearchBar from "../SearchBar/SearchBar.tsx";

interface TableHeaderProps {
  searchValue: string;
  onSearchChange: (newVal: string) => void;
  onImport?: () => void;
  onCreate?: () => void;
  onFilterClick?: () => void; 
}

const TableHeader: React.FC<TableHeaderProps> = ({
  searchValue,
  onSearchChange,
  onImport,
  onCreate,
  onFilterClick 
}) => {
  const { t } = useTranslation();

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      sx={{ padding: "8px 16px" }}
    >
      <SearchBar
        searchValue={searchValue}
        onSearchChange={onSearchChange}
        withFilter
        onFilterClick={onFilterClick} 
        placeholder="Поиск по заказам"
      />

      <Box display="flex" alignItems="center" gap={1}>
        {onImport && (
          <Button size="M" startIcon={<AddIcon />} onClick={onImport}>
            Импорт
          </Button>
        )}
        {onCreate && (
          <Button size="M" startIcon={<AddIcon />} onClick={onCreate}>
            {t("create")}
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default TableHeader;